import type { FaireProductEntity } from "../../entity_types/product";

export const p_p6r3ak2945: FaireProductEntity = {
  token: "p_p6r3ak2945",
  type: "product",
  name: "Arroyo Oak – Incense Sticks",
  brandToken: "b_a9b3b023",
  brandName: "P.F. Candle Co.",
  imageUrl:
    "https://cdn.faire.com/fastly/2165c4c56ba31359cdcd896e8c77308a8954777d08b69fcaab3cdc6c6553dc4d.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ddff4d6cbaa2c4dedf6c710504b872271d5c360673ddb1bbd7785a390becb8d9.jpeg",
    "https://cdn.faire.com/fastly/f88da949ec039a145c0c6448621669d0516c08d7e5bbd78dcf879651934ade85.png",
    "https://cdn.faire.com/fastly/4afab458078f2498b5062052fc198c2520be8310e89e643631ce5314af81d552.jpeg",
    "https://cdn.faire.com/fastly/467121db907c8bdc14b950af627211f9a9e6bfe6f95e5a88d9be1309e9f8c5e8.jpeg",
    "https://cdn.faire.com/fastly/c49631d3764c8627019b9c648e9fbe03227a92b230c0814d52d2c721eefc2c95.jpeg",
    "https://cdn.faire.com/fastly/fed489c7928eb9df432b18bbc3665c24901a3c159ea138ab85a1b1d0584c0579.jpeg",
  ],
  priceDollars: 5,
  description:
    'A love letter to the quiet wild of the Arroyo Seco. A passageway of twisted terrain perfumed by native sagebrush, crushed oak leaves, shady creek beds, and canyon stone. Vetiver, frankincense, & California oak.\n\nOur hand-dipped charcoal incense quickly transforms a room: transformative smoke uplifts the space while our signature scents linger for hours even after extinguishing.\n\nEach stick burns for 1 hour; depending on room size, scent longevity lasts between 2-4 hours. 15 sticks in a plastic sleeve inside of each kraft package, measuring 10.75" long each.',
  tags: [],
  msrpDollars: 11,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-01T19:03:47.466Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
